import { MotiveReportData } from './motive-web-report.types';

export const createMockMotiveReportData = (token: string): MotiveReportData => ({
  participantName: `Participant ${token.slice(0, 6).toUpperCase()}`,
  reportType: 'expert',
  language: 'en',
  createdAt: new Date().toISOString(),
  takeaways: [
    {
      title: 'Strong achievement drive',
      score: 84,
      description: 'You care about quality, progress, and getting measurable results.',
      action: 'Set one visible weekly goal and track it publicly with your team.',
    },
    {
      title: 'Social orientation is balanced',
      score: 64,
      description: 'You work well with others, but you are selective about trust.',
      action: 'Use short alignment check-ins before decisions to keep everyone on board.',
    },
    {
      title: 'Influence is situational',
      score: 58,
      description: 'You can lead strongly when needed, but not in every context.',
      action: 'State your recommendation clearly and explain the impact in one sentence.',
    },
  ],
  stories: [
    {
      id: '1',
      title: 'Story 1 - Launch under pressure',
      imageLabel: 'Story 1',
      text: 'I focused on the deadline and quality, and I pushed the team to close open tasks quickly.',
      tags: ['Deadline', 'Ownership', 'Quality'],
      detections: [
        { motive: 'Achievement', confidence: 92 },
        { motive: 'Power', confidence: 61 },
        { motive: 'Affiliation', confidence: 41 },
      ],
    },
    {
      id: '2',
      title: 'Story 2 - Team conflict',
      imageLabel: 'Story 2',
      text: 'I first tried to calm the group, then I proposed a concrete structure so we could move forward.',
      tags: ['Alignment', 'Structure', 'Conflict resolution'],
      detections: [
        { motive: 'Affiliation', confidence: 81 },
        { motive: 'Power', confidence: 69 },
        { motive: 'Achievement', confidence: 57 },
      ],
    },
  ],
  motiveScores: [
    {
      motive: 'Achievement',
      score: 84,
      color: '#7c8cff',
      description: 'High focus on standards, progress, and performance.',
    },
    {
      motive: 'Affiliation',
      score: 64,
      color: '#3cd3ac',
      description: 'Healthy focus on relationships and group climate.',
    },
    {
      motive: 'Power',
      score: 58,
      color: '#ffb65d',
      description: 'Pragmatic influence behavior with context-based leadership.',
    },
  ],
  nextSteps: [
    'Start meetings with one clear outcome and one owner for the next action.',
    'When tension rises, summarize all viewpoints before giving direction.',
    'Use a weekly reflection: What worked, what blocked progress, what to change.',
    'Ask one trusted colleague for communication feedback after key conversations.',
  ],
});
